import { Injectable } from '@angular/core';
import { GridCriteria } from '../models/grid-criteria';
import { utils as xlsUtils, WorkBook, WorkSheet, writeFile, } from 'xlsx-js-style';

@Injectable({
    providedIn: 'root',
})
export class CcenterExportService {

    exportToExcel(rows: any, ccenterFilter: GridCriteria, descriptionFilter: GridCriteria, fileName: string, excelHeading: string) {
        const workBook = this.createWorkBook(rows, ccenterFilter, descriptionFilter, excelHeading);
        writeFile(workBook, `${fileName}.xlsx`);
    }

    private createWorkBook(rows: any, ccenterFilter: GridCriteria, descriptionFilter: GridCriteria, excelHeading: string) {
        const workBook = xlsUtils.book_new()
        const aoa = this.createWorkbookAoA(rows, ccenterFilter, descriptionFilter, excelHeading);
        const sheet = xlsUtils.aoa_to_sheet(aoa);
        xlsUtils.book_append_sheet(workBook, sheet);
        return workBook;
    }

    private createWorkbookAoA(rows: any, ccenterFilter: GridCriteria, descriptionFilter: GridCriteria, excelHeading: string): any[][] {
        const r = [];
        r.push([{ v: `${excelHeading}`, t: "s", s: { font: { bold: true, sz: 24 } } }]);
        r.push([{ v: "Cost Center:", t: "s", s: { font: { bold: true } } }, ccenterFilter.getCriteriaDescription()]);
        r.push([{ v: "Description:", t: "s", s: { font: { bold: true } } }, descriptionFilter.getCriteriaDescription()]);
        r.push([]);
        r.push([]);
        r.push([{ v: "Cost Center", t: "s", s: { font: { bold: true } } }, { v: "Description", t: "s", s: { font: { bold: true } } }]);
        if (rows.length > 0) {
            r.push(...rows.map(row => [row.costCenter, row.description]))
        }
        return r;
    }



}
